import { MainCard, MainCardTitle, MainCardContent } from "src/components/main-card-type.tsx"
import { useIsVerified } from "src/components/email-verification";
import { Button } from "src/components/ui/button";
import {
    checkCalculatorUsageLimitAndRedirect,
    loadSavedCalculatorData,
    sanitizeBrlValue,
    saveCalculatorData,
} from "src/utils/functions";
import { useEffect, useState } from "react";
import { ResponseProporcional } from "../Proporcional"
export const FeriasProporcionais = ({
    setResults,
}: {
    setResults: (value: ResponseProporcional | null) => void;
}) => {
    const calculatorKey = "salario-ferias";
    const [message, setMessage] = useState<string>("");
    const isVerified = useIsVerified();

    const [valorBruto, setValorBruto] = useState("")
    const [meses, setMeses] = useState("")

    function handleSave() {
        saveCalculatorData(calculatorKey, {
            valorBruto,
            meses,
        });
    }
    function clear() {
        setValorBruto("")
        setMeses("")
    }
    useEffect(() => {
        const savedData = loadSavedCalculatorData(calculatorKey);
        if (!savedData) return;
        setValorBruto((savedData.valorBruto as string) || "");
        setMeses((savedData.meses as string) || "")
    }, []);


    function calculo() {
        if (!valorBruto || valorBruto === "00,00") {
            setMessage("Por favor adicione um valor ao Salario Bruto.");
            setResults(null)
            return;
        }
        if (!meses || meses === "0") {
            setMessage("Por favor adicione uma quantidade de meses")
            setResults(null)
            return
        }
        setMessage("")
        const SalarioBruto = Number.parseFloat(
            valorBruto.replace(/[^0-9,-]+/g, "").replace(",", ".")
        );
        const ValorMes = Number.parseFloat(
            meses.replace(/[^0-9,-]+/g, "").replace(",", ".")
        );
        let valorFinal: number = 0
        let Umterço: number = 0
        let proporcional: number = 0
        let DiasFerias: number = 0

        valorFinal = SalarioBruto * ValorMes / 12
        proporcional = valorFinal
        Umterço = valorFinal / 3
        DiasFerias = (30 / 12) * ValorMes
        valorFinal = valorFinal + (valorFinal / 3)
        valorFinal = Math.round(valorFinal * 100) / 100
        console.log(valorFinal, Umterço, proporcional, DiasFerias);
        const resultado = {
            valorFinal: valorFinal,
            Umterço: Umterço,
            proporcional: proporcional,
            DiasFerias: DiasFerias
        }
        setResults(resultado);

    }
    return (
        <MainCard>
            <MainCardTitle>Calculadora de Férias Proporcionais</MainCardTitle>
            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    handleSave();
                    checkCalculatorUsageLimitAndRedirect(calculo);
                }}
            >
                <MainCardContent>
                    <div>
                        <label className="block mb-2 font-medium text-sm" htmlFor="campo-id">
                            Salario Bruto *
                        </label>
                        <div className="flex border">
                            <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                                R$
                            </span>
                            <input
                                className="flex-1 p-2 min-w-[100px]"
                                id="campo-id"
                                placeholder="00,00"
                                type="text"
                                value={valorBruto}
                                onChange={(event) => setValorBruto(sanitizeBrlValue(event))}
                            />
                        </div>
                    </div>
                    <div>
                        <label className="block mb-2 font-medium text-sm" htmlFor="campo-id">
                            Meses trabalhados *
                        </label>
                        <div className="flex border">

                            <input
                                className="flex-1 p-2 min-w-[100px]"
                                id="campo-id"
                                placeholder="0"
                                type="text"
                                value={meses}
                                onChange={(event) => setMeses(event.target.value)}
                            />
                        </div>
                    </div>



                </MainCardContent>

                <div className="flex justify-between">
                    <Button
                        disabled={!isVerified}
                        type="submit"
                        variant={"default"}
                        className="sm:w-[150px]"
                    >
                        Calcular
                    </Button>

                    <div className="flex flex-col sm:flex-row items-center gap-2">
                        <a
                            href="/calculadoras/salario-ferias"
                            className="text-md text-primary text-center "
                        >
                            Ir para a caculadora de Ferias

                        </a>

                        <Button onClick={clear} variant={"ghost"}>
                            Limpar
                        </Button>
                    </div>
                </div>
            </form>

            <p className="text-red-800 text-center mt-2 font-bold">{message}</p>
        </MainCard >

    )

}